var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tipsMask",style:('background:' + this.bgColor),attrs:{"type":_vm.type}},[_c('img',{attrs:{"src":require("../assets/img/draw_noright.png"),"width":"170","height":"170"}}),_c('p',[_vm._v(_vm._s(_vm.$l(_vm.text)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }